<template>
  <div :class="{'nav-open': $sidebar.showSidebar, 'wrapper': true}">
    <notifications transition-name="notification-list" transition-mode="out-in">

    </notifications>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
    <cookies-popup v-if="piskotkiShowPopup"/>
    <el-dialog
      title="Potrebna dodatna potrditev"
      :visible.sync="$root.kriticniProcesPopup"
      width="30%"
      id="recaptchaWidgetRendererDialog"
      :before-close="zapriPopup"
    >
        <div style="display: flex; justify-content: center;">
            <div id="recaptchaWidgetRenderer">Prišlo je do napake</div>
        </div>
    </el-dialog>

  </div>
</template>
<style lang="scss">
  .notifications.vue-notifyjs {
    .notification-list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .notification-list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .notification-list-enter-active, .notification-list-leave-active {
      transition: opacity 0.4s;
    }
    .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */
    {
      opacity: 0;
    }
  }
  #recaptchaWidgetRendererDialog .el-dialog {
    min-width: 330px;
  }
</style>

<script>
  import CookiesPopup from './components/UIComponents/CookiesPopup.vue'
  import {Dialog} from 'element-ui'

  export default {
    components: {
      CookiesPopup,
      [Dialog.name]: Dialog
    },
    data () {
      return {
        clientAgent: null,
        izbranSap: '',
        seznamStrank: [],
        param: {}
      }
    },
    computed: {
      piskotkiShowPopup () {
        let out = true
        if (this.$route.name === 'Podrobnosti piskotkov') {
          out = false
        }

        return out
      }
    },
    methods: {
      zapriPopup (done) {
        this.$root.kriticniProcesPopup = false
        done()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue